import * as React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

export default function CashlessDocuments({ docDetails }) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = docDetails.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box sx={{ maxWidth: '400', flexGrow: 1, textAlign: 'center' }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'block',
          alignItems: 'center',
          height: 50,
          bgcolor: 'background.default',
          textAlign: 'center'
        }}
      >
        <Typography textAlign={'center'} style={{ paddingTop: '12.5px' }}>
          {docDetails[activeStep].doctype}
        </Typography>
      </Paper>
      <embed
        src={
          process.env.REACT_APP_API_URL + '/cashless/getProofFile?service=' +
          docDetails[activeStep].service + "&key=" +
          docDetails[activeStep].key + "&requestid=" +
          docDetails[activeStep].requestid + "&orderid=" +
          docDetails[activeStep].orderid + "&doctype=" +
          docDetails[activeStep].doctype
        }
        height="400"
      //type="application/pdf"
      ></embed>

      <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  );
}
